import React from 'react';
import { DefaultButton, IButtonStyles } from '@fluentui/react';

const styles : IButtonStyles = {
    root: {
        backgroundColor: '#ffffff',
        color: '#333333',
        borderColor: '#666666',
        padding: 25,
        borderRadius: 5,
    },
    rootHovered: {
        backgroundColor: '#ffffff',
        color: '#333333',
        borderColor: '#666666',
    },
    label: {
        fontWeight: 500,
    },
};

interface IButtonWhiteComponentProps {
    text?: string;
    onClick?: (event: any) => void;
    icon?: string;
    disabled?: boolean;
    className?: string;
};

const ButtonWhiteComponent = (props: IButtonWhiteComponentProps) => {
    return (
        <DefaultButton
            text={props.text}
            onClick={props.onClick}
            iconProps={props.icon ? {
                iconName: props.icon,
            } : {}}
            styles={styles}
            disabled={props.disabled}
            className={props.className} />
    );
};

export default ButtonWhiteComponent;
